export const ERROR = {
	ACTION_CONTEXT_CARRIES_NO_PROPERTY_ID: 'Action context carries no property_id',
	CREATE_SPA_SHELL_WORKER_INSTALLED_NO: 'createSpaShellWorker installed no fetch handler',
	/** `user-create` create-route terminal: the profile INSERT arm answered `route: failed`, or the outcome step recorded nothing at all. Both terminals report the same text, so the two emitters must share it. */
	FAILED_TO_CREATE_PROFILE: 'Failed to create profile',
	/** The fallback wording when the user-create / user-provision input gate refused without naming its own reason.
	 *  Both flows read the SAME gate output and both need a sentence for the reason-less case, so the fallback is one
	 *  decision -- and `flows/auth-login.ts` quotes it in an output-schema description as one of the shapes its `error`
	 *  member can carry, which only stays true while the two producers agree. */
	MFA_PHONE_REQUIRED: 'mfa_phone is required',
	/** `user-provision` find-or-create terminal, emitted from all three verdict sites (the early-failure router, the assembly's unreachable null-profile arm, and the string-returning leg helper). */
	FAILED_TO_FIND_OR_CREATE_PROFILE: 'Failed to find or create profile',
	FAILED_TO_PARSE_RESPONSE_JSON: 'Failed to parse response JSON',
	FAILED_TO_PARSE_WEB_SOCKET_MESSAGE: 'Failed to parse WebSocket message',
	FAILED_TO_UPDATE_BANK_INSTRUCTIONS: 'Failed to update bank instructions',
	FAILED_TO_UPDATE_INVITED_PROFILE: 'Failed to update invited profile',
	FEDERA_D1_BINDING_NOT_AVAILABLE: 'FEDERA D1 binding not available',
	FINDING_NOT_FOUND: 'finding not found',
	HIGHEST_BIDDER_SECURITY_DEPOSIT_WAS_NOT: 'Highest-bidder security deposit was not released; the held funds stayed on the bidder',
	INSTRUMENT_NOT_FOUND: 'instrument not found',
	INVALID_FILE_DATA_URL: 'Invalid file data URL',
	/** `admin-publish-listing`: the publish committed but returned no `property_id`, so the PropertyDO mirror leg has nothing to
	 *  address. Both the per-row batch arm and the single-row graph arm report it, and the two envelopes are compared against
	 *  each other by the publish golden suites -- one spelling, two emitters. */
	NO_PROPERTY_ID_ON_PUBLISHED_TRANSACTION: 'no property_id on the published transaction',
	PARTICIPANT_NOT_FOUND: 'Participant not found',
	PROPERTY_NOT_FOUND: 'property not found',
	QUERY_FAILED: 'Query failed',
	REFUND_GATHER_SCORED_SUBFLOW_PRODUCED_NO: 'refund-gather-scored subflow produced no result',
	/** Third member of the title parent-lookup family beside {@link ERROR.FINDING_NOT_FOUND} and
	 *  {@link ERROR.INSTRUMENT_NOT_FOUND}, and homed here for the same reason: the snapshot update-statement builder is
	 *  the only producer today, but the three refusals are ONE decision about how a title child reports a missing parent
	 *  row, and leaving one of them inline is what lets the family drift a word at a time. */
	SNAPSHOT_NOT_FOUND: 'snapshot not found',
} as const;
